module.exports = __webpack_public_path__ + "img/img01.34260955.png";